<app-loader></app-loader>

<div class="container mb-4 scroll-to arabic-styling next-design">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
